import { NgModule } from '@angular/core';
import { UiSearchComponent } from './search.component';

@NgModule({
  declarations: [ UiSearchComponent ],
  exports: [ UiSearchComponent ]
})
export class UiSearchModule {}
